module.exports = __webpack_public_path__ + "static/media/toggle_on_black_24dp.a51599d1.svg";